export const GET_LIST_REASON = 'GET_LIST_REASON'
export const GET_LIST_REASON_ERR = 'GET_LIST_REASON_ERR'
export const CLEAR_LIST_REASON = 'CLEAR_LIST_REASON'